import { AppError } from './app-error';

export class BadRequest extends AppError{
}


// WEBPACK FOOTER //
// ./src/app/errors/bad-request.ts